/**
 * MultiSelectActionBar
 * ====================
 * Place at: frontend/src/components/map/MultiSelectActionBar.jsx
 *
 * Extracted from Dashboard.jsx (September 2026). It shares no state with
 * the page — it takes props and renders — so living inside a 1,100-line
 * page component bought nothing and cost reuse.
 */

import React from 'react';
import { CheckSquare } from 'lucide-react';
import { Button } from '../ui';


export const MultiSelectActionBar = ({
  isMultiSelectMode, hasHighlightedLineage, onEnterMultiSelect,
}) => {
  if (isMultiSelectMode) return null;
  if (!hasHighlightedLineage) return null;
  return (
    <div className="absolute left-1/2 -translate-x-1/2 bottom-20 z-30 animate-in slide-in-from-bottom-4 duration-300">
      <div className="flex items-center gap-2 px-4 py-3 bg-zinc-900/95 backdrop-blur-xl border border-zinc-700 rounded-2xl shadow-2xl">
        <Button variant="secondary" size="sm" icon={CheckSquare} onClick={onEnterMultiSelect}>
          Multi-select
        </Button>
      </div>
    </div>
  );
};

export default MultiSelectActionBar;